import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axiosInstance from "src/api/axios";
import { toast } from "react-toastify";
import { ACTIVE_LOGIN_ROUTES } from "src/utils/loginRoutes";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

const InstagramBusinessAuth: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const code = urlParams.get("code");
    const userId = localStorage.getItem("userId");

    if (!code) {
      toast.error("No code found in URL");
      setLoading(false);
      return;
    }
    if (!userId) {
      toast.error("User not logged in");
      setLoading(false);
      return;
    }

    const authenticate = async () => {
      try {
        await axiosInstance.post(
          `${backendUrl}/instagram-business/auth`,
          { code, userId }
        );
        toast.success("Instagram Business authenticated successfully!");
        navigate(ACTIVE_LOGIN_ROUTES.dashboard);
      } catch (error: any) {
        toast.error(
          error?.response?.data?.message || error?.message || "Authentication failed"
        );
      } finally {
        setLoading(false);
      }
    };

    authenticate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50">
      <h1 className="text-3xl font-bold mb-4">Instagram Business Auth</h1>
      {loading ? (
        <p className="text-lg text-gray-700">Authenticating...</p>
      ) : (
        <p className="text-lg text-gray-700">
          Please wait or check for errors above.
        </p>
      )}
    </div>
  );
};

export default InstagramBusinessAuth;
